// extracted by mini-css-extract-plugin
export default {"loading":"loading-xuaHy","rotate":"rotate-e7eKU","loadingSmall":"loadingSmall-YNr9O","loadingMedium":"loadingMedium-b4pqW","loadingBig":"loadingBig-whP7D"};